// extracted by mini-css-extract-plugin
export default {"body":"cargo_body__7oBlW","toolbar":"cargo_toolbar__ud8gW","left":"cargo_left__Fw8FC","right":"cargo_right__Gytdp","addition":"cargo_addition__PBgvC"};